import React from "react";
import { defineMessages } from "react-intl";
import { isMessageDescriptor } from "../../intl/hooks.js";
import "../../intl/shared-resources/serverResponse.js";
import { makeStyles } from "tss-react/mui";
import { Button } from "../button/Buttons.js";
import "../button/EditButton.js";
import { LocalizedText } from "../i18n/LocalizedText.js";
import { BulkModalContent } from "./BulkModalContent.js";
import { BulkModalTitle } from "./BulkModalTitle.js";
import { ModalFooter } from "./ModalFooter.js";
const localized = defineMessages({
  confirmButtonLabel: {
    id: "ActionConfirmationModal_confirmButtonLabel",
    defaultMessage: "Yes"
  },
  cancelButtonLabel: {
    id: "ActionConfirmationModal_cancelButtonLabel",
    defaultMessage: "No"
  }
});
const useStyles = makeStyles()({
  actionConfirmationModalContent: {
    height: "unset"
  }
});
function ActionConfirmationModal({
  title,
  contentDescription,
  handleConfirm,
  handleCancel,
  confirmButtonLabel,
  cancelButtonLabel,
  confirmButtonColor = "primary"
}) {
  const { classes } = useStyles();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(BulkModalTitle, null, /* @__PURE__ */ React.createElement(LocalizedText, { label: title })), /* @__PURE__ */ React.createElement(BulkModalContent, { className: classes.actionConfirmationModalContent }, typeof contentDescription === "string" || isMessageDescriptor(contentDescription) ? /* @__PURE__ */ React.createElement(LocalizedText, { label: contentDescription }) : contentDescription), /* @__PURE__ */ React.createElement(ModalFooter, null, /* @__PURE__ */ React.createElement(Button, { label: cancelButtonLabel ?? localized.cancelButtonLabel, onClick: handleCancel }), /* @__PURE__ */ React.createElement(Button, { color: confirmButtonColor, label: confirmButtonLabel ?? localized.confirmButtonLabel, onClick: handleConfirm })));
}
export {
  ActionConfirmationModal
};
//# sourceMappingURL=ActionConfirmationModal.js.map
